import React from "react";
import PackageListTableComponent from "./packageListTable.component";

export default function PackageListTableContainer({
  hasStockflowInventoryViewAccessRight,
  hasStockflowDealerViewAccessRight,
  rows,
  isFetching,
  language,
  selectedIds,
  isSelectAll,
  isError,
  handleReload,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  isSearchResult,
  totalFiltered,
  handleSelectPackage,
  handleSelectAvailable,
  handleSelectAll,
  handleDeselectAll,
  token,
  paginationOptions,
  tableFilter,
  changeOrder,
  lang,
  isDealerPage = false,
  dealerId,
  handleViewDetail
}) {
  return (
    <PackageListTableComponent 
      hasStockflowInventoryViewAccessRight={hasStockflowInventoryViewAccessRight}
      hasStockflowDealerViewAccessRight={hasStockflowDealerViewAccessRight}
      rows={rows}
      isFetching={isFetching}
      language={language}
      isSelectAll={isSelectAll} 
      selectedIds={selectedIds}
      isError={isError}
      handleReload={handleReload}
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangePage={handleChangePage}
      handleChangeRowPerPage={handleChangeRowsPerPage}
      isSearchResult={isSearchResult}
      totalFiltered={totalFiltered}
      handleSelectPackage={handleSelectPackage}
      handleSelectAvailable={handleSelectAvailable}
      handleSelectAll={handleSelectAll}
      handleDeselectAll={handleDeselectAll}
      token={token}
      paginationOptions={paginationOptions}
      tableFilter={tableFilter}
      changeOrder={changeOrder}
      lang={lang}
      isDealerPage={isDealerPage}
      dealerId={dealerId}
      handleViewDetail={handleViewDetail}
    />
  )
}